import { defineComponent as _defineComponent } from 'vue'
import "vue3-carousel/dist/carousel.css";
import { ref, Ref } from "vue";
import { Carousel, Slide } from "vue3-carousel";


export default /*#__PURE__*/_defineComponent({
  __name: 'reference-slider',
  props: {
    slides: { type: Array, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

// If you are using PurgeCSS, make sure to whitelist the carousel CSS classes


const slider: Ref<typeof Carousel | null> = ref(null);

const next = () => {
    slider.value!.next();
};
const prev = () => {
    slider.value!.prev();
};

const __returned__ = { slider, next, prev, Carousel, Slide }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})